import React, { Component } from 'react';
import APIFetcher from "../../API";
import {Link} from "react-router-dom";
import {SortableContainer, SortableElement} from "react-sortable-hoc";

class GroupsPage extends Component {
    constructor(props) {
        super(props);

        this.state = {loading: true, groups: [], error: null};
    }

    componentDidMount() {
        APIFetcher.getGroups()
            .then(response => {
                this.setState({loading: false, groups: response.data, error: null})
            })
            .catch(error => {
                this.setState({loading: false, groups: [], error: error})
            })
    }


    render() {
        let content;
        if (this.state.loading) {
            content = <p>loading</p>
        } else if (this.state.error) {
            content = <p>error</p>
        } else {
            let arrayMove = (arr, old_index, new_index) => {
                if (new_index >= arr.length) {
                    let k = new_index - arr.length + 1;
                    while (k--) {
                        arr.push(undefined);
                    }
                }
                arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
            }

            let onSortEnd = ({oldIndex, newIndex}) => {
                let newGroups = this.state.groups;
                arrayMove(newGroups, oldIndex, newIndex);
                this.setState({loading: false, groups: newGroups, error: this.state.error})
                let groupsIds = newGroups.map(group => group.id);
                APIFetcher.orderGroups(groupsIds)
                    .then((response) => {

                    })
                    .catch(error => {
                    })
            };

            const SortableItem = SortableElement(({value}) => {
                return <Link className="list-group-item list-group-item-action"
                             to={{
                                 pathname: "/groups/" + value.id + "/edit",
                                 state: value
                             }}>{value.name}</Link>
            });

            const SortableList = SortableContainer(({items}) => {
                return (
                    <ul className="list-group shadow-sm mb-5 bg-body rounded">
                        {items.map((value, index) => (
                            <SortableItem key={value.id} index={index} value={value}/>
                        ))}
                    </ul>
                );
            });

            content = <SortableList pressDelay={300} items={this.state.groups} onSortEnd={onSortEnd}/>
        }

        return <div className="container-sm">
            <div className="p-3">
                <p className="text-center h2">Liste des groupes</p>
                <nav className="navbar">
                    <div className="container-fluid">
                        <div className="fw-light">Glisser / déposer (maintenir) pour changer l'ordre</div>
                        <Link className="nav-link active" to="/groups/new">Créer un groupe</Link>
                    </div>
                </nav>
                {content}
            </div>
        </div>
    }
}

export default GroupsPage;
